import React, { Component } from 'react';
import { API } from '../api/API';
import { Global } from '../api/Global';

class ActionButtons extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showBtns: false,
    };
  }
  showBtn = async () => {
    try {
      await this.setState({
        showBtns: true,
      });
    } catch (error) {
      console.log(error);
    }
  };
  hideBtn = async () => {
    try {
      await this.setState({
        showBtns: false,
      });
    } catch (error) {
      console.log(error);
    }
  };
  likePost = async () => {
    try {
      let obj = {
        newsFeedClientId: this.props.newsFeedClientID,
        urlParams: window.location.href.split('?')[1],
      };

      console.log('👆 Like button clicked, emitting:', obj);

      if (Global.socket) {
        Global.socket.emit('like', obj);
        console.log('✅ Like event emitted via socket');
      } else {
        console.error('❌ Socket not available');
      }
    } catch (error) {
      console.log(error);
    }
  };
  isAuthorizeUser() {
    try {
      let status = true;
      let user = Global.user();

      if (user === 'learner' && !this.props.isCommentable) {
        status = false;
      }

      return status;
    } catch (error) {
      console.log(error);
    }
  }
  render() {
    const { totalComments, likedByUser } = this.props;
    console.log('🎨 ActionButtons render - likedByUser:', likedByUser, 'postID:', this.props.newsFeedClientID);
    return (
      <div className="actionButtons">
        <div className="leftSide">
          {!this.state.showBtns ? (
            <button className="link" onClick={() => this.likePost()}>
              {likedByUser ? (
                <img src="/img/thumbs-active-small.svg" alt="Like" />
              ) : (
                <img src="/img/thumbs.svg" alt="Like" />
              )}

              <span>Like</span>
            </button>
          ) : (
            <div className="btns" onMouseLeave={() => this.hideBtn()}>
              <button className="likeme">
                <span>Like</span>
              </button>
              <button className="interest">
                <span>Interest</span>
              </button>
              <button className="laugh">
                <span>Laugh</span>
              </button>
            </div>
          )}
        </div>
        <div className="rightSide">
          {this.isAuthorizeUser() ? (
            <button
              className="link comments"
              onClick={() => this.props.onCommentStatus(true)}
            >
              <img src="/img/comment.svg" alt="Comment" />
              <span>
                {totalComments > 0 ? totalComments : '0'}
                {totalComments > 1 ? (
                  <span className="xs-hide">Comments</span>
                ) : (
                  <span className="xs-hide">Comment</span>
                )}
              </span>
            </button>
          ) : (
            ''
          )}
        </div>
      </div>
    );
  }
}

export default ActionButtons;
